export default {"src":"/_next/static/media/pendants.f074b918.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};